var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ext3_2",
    x: 0.908203,
    width: 40,
    height: 40,
    rx: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1456_168927)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ext3_2_i",
    d: "M21.6582 12.5C19.999 12.5 18.6582 13.8408 18.6582 15.5V16.25H14.1657C13.4252 16.25 12.7408 16.6566 12.3923 17.3177L9.85222 22.1491L9.84172 22.1729C9.72916 22.4288 9.6582 22.6677 9.6582 23V23.75H10.3407C10.7907 23.75 11.1582 24.1175 11.1582 24.5675V25.9325C11.1582 26.3825 10.7907 26.75 10.3407 26.75H9.73962C9.99081 27.6194 10.7942 28.2575 11.7432 28.2575H11.9296C11.9155 28.132 11.9082 28.0043 11.9082 27.875C11.9082 26.011 13.4192 24.5 15.2832 24.5C17.1472 24.5 18.6582 26.011 18.6582 27.875C18.6582 28.0043 18.6509 28.132 18.6368 28.2575H23.1796C23.1655 28.132 23.1582 28.0043 23.1582 27.875C23.1582 26.011 24.6692 24.5 26.5332 24.5C28.3972 24.5 29.9082 26.011 29.9082 27.875C29.9082 28.0043 29.9009 28.132 29.8868 28.2575H30.0582C31.0093 28.2575 31.8161 27.6198 32.0729 26.75H31.8207C31.2132 26.75 30.6882 26.285 30.6582 25.6775C30.6282 25.0325 31.1457 24.5 31.7832 24.5H32.1582V15.5C32.1582 13.8408 30.8174 12.5 29.1582 12.5H21.6582ZM20.1582 23V15.5C20.1582 14.6692 20.8274 14 21.6582 14H29.1582C29.989 14 30.6582 14.6692 30.6582 15.5V23H20.1582ZM19.4082 23H11.1582C11.1582 22.9485 11.1626 22.9234 11.1668 22.906C11.1714 22.8868 11.1805 22.8569 11.2051 22.7992L11.4938 22.25H15.5832C16.0407 22.25 16.4082 21.8825 16.4082 21.425V19.3325C16.4082 18.875 16.0407 18.5075 15.5832 18.5075H13.4614L13.7192 18.0172C13.8057 17.8533 13.9762 17.75 14.1657 17.75H19.4082V23Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext3_2_i",
    d: "M17.9082 27.875C17.9082 29.3247 16.733 30.5 15.2832 30.5C13.8335 30.5 12.6582 29.3247 12.6582 27.875C12.6582 26.4253 13.8335 25.25 15.2832 25.25C16.733 25.25 17.9082 26.4253 17.9082 27.875ZM15.2832 29C15.9045 29 16.4082 28.4963 16.4082 27.875C16.4082 27.2537 15.9045 26.75 15.2832 26.75C14.6619 26.75 14.1582 27.2537 14.1582 27.875C14.1582 28.4963 14.6619 29 15.2832 29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext3_2_i",
    d: "M29.1582 27.875C29.1582 29.3247 27.983 30.5 26.5332 30.5C25.0835 30.5 23.9082 29.3247 23.9082 27.875C23.9082 26.4253 25.0835 25.25 26.5332 25.25C27.983 25.25 29.1582 26.4253 29.1582 27.875ZM26.5332 29C27.1545 29 27.6582 28.4963 27.6582 27.875C27.6582 27.2537 27.1545 26.75 26.5332 26.75C25.9119 26.75 25.4082 27.2537 25.4082 27.875C25.4082 28.4963 25.9119 29 26.5332 29Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1456_168927"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ext3_2_i",
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8.9082 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/Truck.ec99aa52.svg";
export { ForwardRef as ReactComponent };